import React, { Component } from 'react';
import LeftCaret from 'react-icons/lib/fa/caret-left';
import RightCaret from 'react-icons/lib/fa/caret-right';
import CheckIcon from 'react-icons/lib/md/check';
import TimerIcon from 'react-icons/lib/md/timer';

import Tooltip from 'rc-tooltip';

import { parseTime, secondsToString } from './TimeUtils';

if (typeof window !== 'undefined') {
  require('rc-tooltip/assets/bootstrap.css');
}

export default class TimeControl extends Component {
  constructor() {
    super();

    this.state = {
      focused: false,
    };

    this.setState = this.setState.bind(this);
  }

  blur() {
    this.refs.control.blur();
  }

  set(value) {
    this.refs.control.value = value;
  }

  nextFrame() {
    let newStart = this.props.value + 0.03;
    if (newStart > this.props.duration) {
      newStart = this.props.duration;
    }
    this.props.onChange(newStart, false);
    this.refs.control.value = secondsToString(newStart);
  }

  prevFrame() {
    let newStart = this.props.value - 0.03;
    if (newStart < 0) {
      newStart = 0;
    }
    this.props.onChange(newStart, false);
    this.refs.control.value = secondsToString(newStart);
  }

  render() {
    return (
      <div className="clip-controls-time-control">
        <input
          className="clip-controls-time-control-text form-control"
          type="text"
          defaultValue={secondsToString(this.props.value)}
          onChange={(e) => {
            // this.props.onChange(parseTime(e.target.value))
          }}
          onKeyDown={(e) => {
            if (e.keyCode === 39 || e.keyCode === 38) {
              e.preventDefault();
              this.nextFrame();
              this.refs.nextFrame.className += ' active';
            } else if (e.keyCode === 37 || e.keyCode === 40) {
              e.preventDefault();
              this.prevFrame();
              this.refs.prevFrame.className += ' active';
            } else if (e.keyCode === 13) {
              e.preventDefault();
              this.props.onChange(this.props.value, true);
              this.blur();
            } else if (e.keyCode === 27) {
              e.preventDefault();
              this.refs.control.value = secondsToString(this.props.value);
              this.props.onChange(this.props.value, true);
              this.blur();
            }
          }}
          onKeyUp={(e) => {
            this.refs.nextFrame.className =
              this.refs.nextFrame.className.replace(/active/g, '');
            this.refs.prevFrame.className =
              this.refs.prevFrame.className.replace(/active/g, '');
          }}
          onFocus={(e) => {
            this.props.onChange(this.props.value, false);
            this.setState({
              focused: true,
            });
          }}
          onBlur={(e) => {
            if (
              e.relatedTarget &&
              (e.relatedTarget === this.refs.nextFrame ||
                e.relatedTarget === this.refs.prevFrame ||
                e.relatedTarget === this.refs.now)
            ) {
              e.preventDefault();
              return;
            }

            let newStart = parseTime(e.target.value);
            /* if (newStart > this.props.clipEnd) {
              newStart = this.props.clipEnd - 1
            }
            if (newStart < 0) {
              newStart = 0
            }*/
            this.refs.control.value = secondsToString(newStart);

            this.setState({
              focused: false,
            });

            this.props.onChange(
              newStart,
              !(
                e.relatedTarget &&
                e.relatedTarget
                  .getAttribute('class')
                  .indexOf('clip-controls-time-control-text') !== -1
              )
            );
          }}
          ref="control"
        />
        {!this.props.mobile ? (
          this.state.focused ? (
            <span>
              <button
                ref="prevFrame"
                className="clip-controls-time-action prev-frame"
                onClick={() => {
                  this.prevFrame();
                  setTimeout(() => this.refs.control.focus(), 0);
                }}
              >
                <LeftCaret />
              </button>
              <button
                ref="nextFrame"
                className="clip-controls-time-action next-frame"
                onClick={() => {
                  this.nextFrame();
                  setTimeout(() => this.refs.control.focus(), 0);
                }}
              >
                <RightCaret />
              </button>
              <button
                ref="finishEditing"
                className="clip-controls-time-action finish"
                onClick={() => {
                  this.props.onChange(this.props.value, true);
                  this.blur();
                }}
              >
                <CheckIcon />
              </button>
            </span>
          ) : (
            <button
              ref="now"
              className="clip-controls-time-action"
              onClick={() => {
                this.props.onChange(null, true);
                setTimeout(() => this.refs.control.focus(), 0);
              }}
            >
              <Tooltip
                placement="top"
                overlay={
                  <span style={{ whiteSpace: 'nowrap' }}>
                    {this.props.name} at current time
                  </span>
                }
              >
                <TimerIcon />
              </Tooltip>
            </button>
          )
        ) : (
          ''
        )}
      </div>
    );
  }
}
